<template>
  <main class="main">
      <div class="table">
        <loading-container :loading="loading" >
        <div>
            Поставщик: {{provider}}
        </div>
        <br>
        <table >
          <tr>
            <th>Бренд</th>
            <th>Комиссия, %</th>
          </tr>
          <tr v-for="(item, idx) in commission" :key="idx">
            <td>
                {{item.brand}}
            </td>
            <td>
                {{item.commission}}
            </td>
          </tr>
        </table>
      </loading-container>
      </div>
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";

export default {
  name: "provider-commission",
  components: {
    LoadingContainer
  },
  data: ()=>({
    loading: true,
    commission: null,
    provider: null
  }),
  mounted() {
    this.getCommission();
  },
  methods: {
    getCommission(){
      this.$http.post('/get-provider-commission', {
        token: localStorage.getItem('token'),
        id: this.$route.params.id
      }).then(({data}) => {
        if (data.commission){
          this.commission = data.commission;
          this.provider = data.provider;
          this.loading = false;
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.ml-3 {
    width: 220px;
    margin-top: 20px;
}
.table{
  margin-top: 20px;
  table{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    tr{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;

      th{
        color: #2D3137;
      }
      td{
        color: #636974;
        &.done{
          color: #2cb181;
        }
      }
    }
  }
}


</style>
